module.exports = __webpack_public_path__ + "static/media/mint-and-maintain.d39c3312.png";